// ** MUI Imports
import { Fab, InputAdornment } from '@mui/material'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'

// ** Icon Imports

import Icon from '../../../@core/components/icon'
import CustomTextField from '../../../@core/components/mui/text-field'

// ** Components
// import ModeToggler from 'src/@core/layouts/components/shared-components/ModeToggler'
import UserDropdown from '../../../@core/layouts/components/shared-components/UserDropdown'
import Autocomplete from '../../../@core/components/Autocomplete'
import { useSmartClaim } from '../../../hooks/smartClaim'
import { useTrueClaim } from '../../../hooks/trueClaim'
import { useLocation } from 'react-router-dom'
import { userData } from '../../../hooks/userData'

const AppBarContent = props => {
  // ** Props
  const { hidden, settings, saveSettings, toggleNavVisibility } = props

  const tc_claim = useTrueClaim();
  const sc_claim = useSmartClaim();
  const gstList = userData();

  const location = useLocation()
  const handleReload = async () => {
    try {
      if (['/customer-return', '/wrong-rto', '/non-barcode-rto', '/damage', '/missing-qty'].includes(location.pathname)) {
        sc_claim.setLoading(true)
        await sc_claim.completedClaim();
      } else if (location.pathname === '/payment') {
        tc_claim.setLoading(true)
        await tc_claim.trueClaim({ paymentNotReceived: true });
      } else if (location.pathname === '/returns') {
        tc_claim.setLoading(true)
        await tc_claim.trueClaim({ returnNotReceived: true });
      } else if (location.pathname === "/lost") {
        tc_claim.setLoading(true)
        await tc_claim.trueClaim({ orderType: "LOST" });
      } else if (location.pathname === '/otp-less') {
        tc_claim.setLoading(true)
        await tc_claim.trueClaim({ intransit: true });
      }

      await gstList.gstList();

    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      sc_claim.setLoading(false)
      tc_claim.setLoading(false)
    }
  };

  return (
    <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Box className='actions-left' sx={{ mr: 2, display: 'flex', alignItems: 'center' }}>
        {hidden && !settings.navHidden ? (
          <IconButton color='inherit' sx={{ ml: -2.75 }} onClick={toggleNavVisibility}>
            <Icon fontSize='1.5rem' icon='tabler:menu-2' />
          </IconButton>
        ) : null}
      </Box>
      <Box className='actions-left' sx={{ mr: 2, display: 'flex', alignItems: 'center' }}>
        {/* <CustomTextField
          fullWidth

          // value={query}
          // onChange={handleFilter}
          placeholder='Search Order...'
          sx={{ '& .MuiInputBase-root': { borderRadius: '30px !important' } }}
          InputProps={{
            endAdornment: (
              <InputAdornment position='start' sx={{ color: 'text.secondary' }}>
                <IconButton
                  edge='end'

                  // onClick={handleClickShowPassword}
                  onMouseDown={e => e.preventDefault()}
                  aria-label='toggle password visibility'
                >
                  <Icon fontSize='1.25rem' icon='tabler:search' />
                </IconButton>
              </InputAdornment>
            )
          }}
        /> */}
        <Autocomplete hidden={hidden} settings={settings} />
      </Box>
      <Box className='actions-right' sx={{ display: 'flex', alignItems: 'center' }}>
        <Fab  color='primary' variant='extended' sx={{ '& svg': { mr: 1 } }} size='small' onClick={handleReload}>
          <Icon icon="ix:reload" width="20" height="20" />
          refresh
        </Fab>
        <UserDropdown settings={settings} />
      </Box>
    </Box>
  )
}

export default AppBarContent
